/**
* Javascript initiation script
*
* @package Wordpress/uwa-mv
* @author LV UWA MV <k.schaake@uwa-mv.de>
* @since 1.0.0
*/

// create app-object
if( !window.asscript || window.asscript === 'undefined' ) {
  window.asscript = {};
}
var asscript = window.asscript;
